/** query параметры bootstrap Messenger to Meet */
export const MEET_BOOTSTRAP_QUERY_PARAMS = [
    'joinApprovalPolicy',
    'initiatorId',
    'callId',
    'workspaceId',
    'token',
    'wss',
    'soundEnabled',
    'notificationsEnabled',
    'fullName',
    'language',
    'types',
] as const;

export type MeetBootstrapQueryParam = (typeof MEET_BOOTSTRAP_QUERY_PARAMS)[number];
